import Vue from 'vue';
import VueTheMask from 'vue-the-mask';
import CardFile from '@/components/app/card/CardFile/Index.vue';
import CardRadio from '@/components/app/card/CardRadio/Index.vue';
import CardCheck from '@/components/app/card/CardCheck/Index.vue';
import CardSelect from '@/components/app/card/CardSelect/Index.vue';
import CardShortText from '@/components/app/card/CardShortText/Index.vue';
import App from './App.vue';

import './registerServiceWorker';

import router from './router';
import store from './store';

import i18n, { setupLanguage } from './plugins/i18n';
import vuetify from './plugins/vuetify';
import './plugins/vue-virtual-scroller';
import './plugins/vue-flip-counter';

import { setupBaseURL, setupApiOnResponseError } from './services/api-recebimentoweb';
import { ROUTE_SIGN_IN } from './constants/ROUTES';

Vue.component('CardFile', CardFile);
Vue.component('CardRadio', CardRadio);
Vue.component('CardCheck', CardCheck);
Vue.component('CardSelect', CardSelect);
Vue.component('CardShortText', CardShortText);

Vue.config.productionTip = false;

Vue.use(VueTheMask);

Promise.all([
  setupLanguage(Array.from(navigator.languages)),
  setupBaseURL(),
  setupApiOnResponseError(async (err) => {
    if (err.response?.status === 401 && store.getters['auth/accessToken']) {
      await store.dispatch('auth/unauthenticate');

      if (router.currentRoute.path === ROUTE_SIGN_IN.path) return;

      router.push({
        path: ROUTE_SIGN_IN.name,
        query: { origin: router.currentRoute.fullPath },
      });
    }

    throw err;
  }),

])
  .then(() => {
    store.dispatch('$_setup');
  })
  .then(() => {
    new Vue({
      router,
      store,
      i18n,
      vuetify,
      render: (h) => h(App),
    }).$mount('#app');
  });
